const userProfile = { data: [], loading: true };

export const GetUserProfile = (state = userProfile, action) => {
  switch (action.type) {
    case "get_userprofile":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
